import script from "./OrderSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSummary.vue?vue&type=script&setup=true&lang=js"

import "./OrderSummary.vue?vue&type=style&index=0&id=1ebb087c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebb087c"]])

export default __exports__